module.exports = __webpack_public_path__ + "static/media/recent-01.ebed8633.jpg";